import * as React from "react";
import { ShieldCheck, Settings2, TrendingUp, Headset } from "lucide-react";
import { Separator } from "@/components/ui/separator";
const features = [{
  icon: ShieldCheck,
  title: "Rapid Execution",
  description: "Engineered for speed with response times that keep your startup moving at full velocity."
}, {
  icon: Settings2,
  title: "Flat-Fee Pricing",
  description: "Predictable $110/device billing including RMM and updates. No markups, no surprises."
}, {
  icon: TrendingUp,
  title: "Elastic Growth",
  description: "A scalable IT architecture designed to pivot and expand as you hit your next funding milestone."
}, {
  icon: Headset,
  title: "true Partnership",
  description: "Fractional IT expertise that integrates with your team to solve complex technical challenges."
}];
export default function WhyShopWithUs() {
  return <section data-section-id="223864" id="our-core-values" className="bg-background text-foreground py-20">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col md:flex-row items-center justify-between w-full">
          {features.map((feature, i) => <div data-index={i} key={i} className="flex flex-col md:flex-row items-center flex-1 w-full">
              <div className="flex flex-col items-center text-center px-4 md:px-8 py-8 md:py-0 w-full">
                <feature.icon className="w-6 h-6 mb-4 text-primary" strokeWidth={1.5} />
                <h3 className="font-default font-bold text-sm mb-2 text-foreground tracking-widest uppercase">
                  {feature.title}
                </h3>
                <p className="font-default text-muted-foreground text-sm max-w-[200px] leading-relaxed">
                  {feature.description}
                </p>
              </div>

              {i < features.length - 1 && <div className="flex items-center justify-center w-full md:w-auto shrink-0">
                  <Separator orientation="vertical" className="hidden md:block h-16 bg-border/30" />
                  <Separator orientation="horizontal" className="md:hidden w-16 bg-border/30" />
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}